<template>
<div id="sidebar-container" class="sidebar-expanded">
        <!-- d-* hiddens the Sidebar in smaller devices. Its itens can be kept on the Navbar 'Menu' -->
        <!-- Bootstrap List Group -->
        <ul class="list-group">
            <a data-toggle="sidebar-colapse" class="bg-dark list-group-item list-group-item-action d-flex align-items-center" @click="SidebarCollapse()">
                <div class="d-flex w-100 justify-content-start align-items-center">
                    <span id="collapse-icon" class="fa fa-fw mr-3"></span>
                    <span id="collapse-text" class="menu-collapsed"></span>
                </div>
            </a>
            <!-- Separator with title -->
            <li class="list-group-item sidebar-separator-title text-muted d-flex align-items-center menu-collapsed">
                <small>Leasing NC</small>
            </li>
                <div v-for="(i, index) in items" v-bind:key="index">
                <router-link :to="{ name: i.enlace }" class="bg-dark list-group-item list-group-item-action" v-if="i.submenu==='0'">
                <div class="d-flex w-100 justify-content-start align-items-center">
                    <span class="fa fa-fw mr-3" :class="i.icon"></span>
                    <span class="menu-collapsed" v-if="!collapsemenu">
                        {{i.menu}}
                    </span>
                </div>
                </router-link>
                <a class="bg-dark list-group-item list-group-item-action btn-administracion" @click="showSubmenu(i.menu)" v-else>
                <div class="d-flex w-100 justify-content-start align-items-center" >
                    <span class="fa fa-users-cog mr-3" :class="i.icon"></span>
                    <span class="menu-collapsed" v-if="!collapsemenu">
                        {{i.menu}}
                    </span>
					<span class="fa fa-angle-up" v-if="submenu && i.menu===menu"></span>
					<span class="fa fa-angle-down" v-else></span>

                </div>
                </a>
                <div class="box-submenu" v-for="(s, index) in items2" v-bind:key="s.menu+'-'+index" >
                <router-link :to="{ name: s.enlace}" class="bg-dark list-group-item list-group-item-action" v-if="s.menu===i.menu && i.menu===menu && submenu===1">
                <div class="d-flex w-100 justify-content-start align-items-center" v-if="submenu===1 && s.menu===menu">
                    <span class="fa fa-fw mr-3" :class="s.icon"></span>
                    <span class="menu-collapsed" v-if="!collapsemenu">
                        {{s.submenu}}
                    </span><br>
                </div>

                </router-link>
                </div>
                </div>

            <!-- Separator without title -->
            <!--<li class="list-group-item sidebar-separator menu-collapsed"></li>-->
            <!-- /END Separator -->

            <span id="boton-expande" class="d-flex align-items-center justify-content-center" @click="showForm()" v-if="filter==='filter'">
                <i class="material-icons">search</i>
            </span>
            <span id="boton-expande2" class="d-flex align-items-center justify-content-center" @click="showForm()" v-if="filter==='client'">
                <i class="material-icons">chevron_left</i>
            </span>
          <!-- List Group END-->
        </ul>
</div>
</template>
<script>

import $ from 'jquery'
import { mapState, mapActions } from 'vuex'
export default {
	name: 'Sidebar',
	methods: {
		...mapActions(['doSearchmenu', 'doCollapsemenu']),
		SidebarCollapse () {
			$('.menu-collapsed').toggleClass('d-none')
			$('.sidebar-submenu').toggleClass('d-none')
			$('.submenu-icon').toggleClass('d-none')
			$('#sidebar-container').toggleClass('sidebar-expanded sidebar-collapsed')

			// Treating d-flex/d-none on separators with title
			var SeparatorTitle = $('.sidebar-separator-title')
			if (SeparatorTitle.hasClass('d-flex')) {
				SeparatorTitle.removeClass('d-flex')
				this.doCollapsemenu(true)
			} else {
				SeparatorTitle.addClass('d-flex')
				this.doCollapsemenu(false)
			}

			// Collapse/Expand icon
			$('#collapse-icon').toggleClass('fa-angle-double-left fa-bars')
		},
		toggleMenuForm () {
			$('#sidebar-container-formulario').toggleClass('d-md-block sidebar-expanded sidebar-form-collapsed')
		},
		showForm () {
			let buttoniconsclass = 'chevron_left'

			if (this.searchmenu) {
				this.doSearchmenu(false)

				buttoniconsclass = 'chevron_right'
			} else {
				this.doSearchmenu(true)
			}

			$('#boton-expande2').find('i').html(buttoniconsclass)
		},
		showSubmenu (menu) {
			if (this.menu !== menu) {
				this.submenu = 0
				this.menu = menu
				this.showSubmenu(menu)
				return false
			}

			this.menu = menu
			if (this.submenu === 0) { this.submenu = 1 } else { this.submenu = 0 }
		}
	},
	ready: function () {
	},
	mounted () {
		$('#body-row .collapse').show('slow')
		// Collapse/Expand icon
		$('#collapse-icon').addClass('fa-angle-double-left')
		this.SidebarCollapse()
		this.toggleMenuForm()
		this.showForm()
		var add = 0
		this.accessMenu.forEach((value, key) => {
			this.items.forEach((value1, key) => {
				if (value1.menu === value.menu) { add = 1 }
			})
			if (value.tipo === '1' && add === 0) { this.items.push({ menu: value.menu, enlace: value.enlace, submenu: value.submenu, icon: value.fa_icon }) }
			add = 0
		})
		this.accessMenu.forEach((value, key) => {
			if (value.submenu.length > 1) { this.items2.push({ menu: value.menu, submenu: value.submenu, enlace: value.enlace, icon: value.fa_icon_p }) }
		})
	},
	data () {
		return {
			// Note 'isActive' is left out and will not appear in the rendered table
			iscollapse: true,
			submenu: 0,
			items: [],
			items2: [],
			Subitems: [],
			menu: ''
		}
	},
	computed: {
		...mapState([
			'accessToken',
			'searchmenu', 'filter', 'collapsemenu', 'accessMenu'])
	}
}
</script>



// WEBPACK FOOTER //
// src/components/layout/Sidebar.vue